import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLocationSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLocationSparkle"><Path d="M7.75 6H12.5V7.5H7.75V16H5.25C4.2835 16 3.5 16.7835 3.5 17.75C3.5 18.7165 4.2835 19.5 5.25 19.5H19.5V13.5H21V21H5.25C3.45507 21 2 19.5449 2 17.75V6.25C2 4.45507 3.45507 3 5.25 3H7.75V6Z" fill="currentColor"/><Path d="M18.4004 4L19.4004 6.59961L22 7.59961V8.40039L19.4004 9.40039L18.4004 12H17.5996L16.5996 9.40039L14 8.40039V7.59961L16.5996 6.59961L17.5996 4H18.4004Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLocationSparkle;
